const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
	const { buttonColor, buttonTextColor, buttonHoverColor, buttonHoverTextColor } = attributes;

	return (
		<>
			<div className="WPForm WPForm-email">
				<InnerBlocks.Content/>
			<style>
				{`
					.WPForm-email .wpforms-submit-container button {
						color: ${ buttonTextColor.hex } !important;
						background-color: ${ buttonColor.hex } !important;
					}

					.WPForm-email .wpforms-submit-container button:hover {
						color: ${ buttonHoverTextColor.hex } !important;
						background: ${ buttonHoverColor.hex } !important;
					}
				`}
			</style>
			</div>
		</>
	);
};
